import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { modalTypes } from "../../constants/modalTypes";
import * as actions from "../../actions/actions";

const IconShareRaw = props => {
    let { icon, navigate, location, downloadFlowModalStep } = props;

    return (
        <a
            data-test-id="icon-share"
            className="icon-share react-share ui_share"
            href="#"
            onClick={e => {
                e.preventDefault();
                downloadFlowModalStep(
                    navigate,
                    location,
                    modalTypes.ICON_SHARE,
                    { icon }
                );
            }}
        />
    );
};

const ConnectedIconShare = connect(null, {
    downloadFlowModalStep: actions.downloadFlowModalStep
})(IconShareRaw);

// Wrapper component to provide navigation
const IconShareWithRouter = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <ConnectedIconShare {...props} navigate={navigate} location={location} />;
};

export default IconShareWithRouter;
